import { yupResolver } from "@hookform/resolvers/yup";
import { LoadingButton } from "@mui/lab";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  Radio,
  RadioGroup,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import axios from "axios";
import { t } from "i18next";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { FormProvider, RHFTextField } from "src/components/hook-form";
import Translate from "src/components/translate";
import useErrors from "src/hooks/useErrors";
import axiosInstance from "src/utils/axios";
import Transition from "src/utils/dialog-animation";
import serializeDate from "src/utils/serialize-date";
import * as Yup from "yup";

const validationSchema = Yup.object({
  status: Yup.string().required(),
  prescription: Yup.string().when("status", {
    is: "complete",
    then: (schema) => schema.required("errors.member.statuscomplete.required"),
    otherwise: (schema) => schema.notRequired(),
  }),
});

const defaultValues = {
  prescription: "",
  status: "pending",
};

const StatusdDialog = ({
  page,
  filter,
  selectedId,
  open,
  status,
  onClose,
  fetchData,
}) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const { enqueueSnackbar } = useSnackbar();
  const handleErrors = useErrors();
  const methods = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues,
  });
  const statusValue = methods.watch("status");
  const onSubmit = async (inputData) => {
    console.log(inputData);
    const reqData = new FormData();

    [...Object.entries(inputData)].forEach(([key, value]) =>
      reqData.append(key, value)
    );
    reqData.append("status", inputData.status);
    reqData.append("purchase_id", selectedId);

    try {
      const { status, data } = await axiosInstance.post(
        `/api/admin/update-health-status/${statusValue}/${selectedId}`,
        reqData
      );
      if (status === 200) {
        // fetchData(page, filter);
        const { start_date, end_date } = filter;
        fetchData(page, {
          ...filter,
          start_date: serializeDate(start_date),
          end_date: serializeDate(end_date),
        });
        onClose();
        enqueueSnackbar(data.message);
      }
    } catch (err) {
      handleErrors(err);
    }
  };

  useEffect(() => {
    if (!open) return;

    methods.reset({
      prescription: "",
      status: status || "pending",
    });
  }, [open, selectedId, status]);

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={open}
      onClose={onClose}
      aria-labelledby="change-username"
      TransitionComponent={Transition}
    >
      <DialogTitle id="change-username">
        <Translate> {"consultation.change_status"}</Translate>
      </DialogTitle>
      <FormProvider methods={methods} onSubmit={methods.handleSubmit(onSubmit)}>
        <DialogContent>
          <DialogContentText>
            <Box
              sx={{
                display: "grid",
                rowGap: 3,
                columnGap: 2,
                marginTop: 1,
                gridTemplateColumns: {
                  xs: "repeat(1, 1fr)",
                  sm: "repeat(1, 1fr)",
                },
              }}
            >
              <RadioGroup
                row
                aria-labelledby="demo-radio-buttons-group-label"
                value={statusValue}
                name="status"
                onChange={(e) => methods.setValue("status", e.target.value)}
                sx={{ gap: 2 }}
              >
                <FormControlLabel
                  sx={{ marginBottom: "0.3rem" }}
                  value="pending"
                  control={<Radio size="small" />}
                  label={t("consultation.pending")}
                />
                <FormControlLabel
                  sx={{ marginBottom: "0.3rem" }}
                  value="complete"
                  control={<Radio size="small" />}
                  label={t("consultation.complete")}
                />
              </RadioGroup>
            </Box>
            {statusValue === "complete" && (
              <RHFTextField
                name="prescription"
                label={"Prescription"}
                multiline
                rows={4}
              />
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} autoFocus color="error">
            <Translate>network_members.close</Translate>
          </Button>
          <LoadingButton
            type="submit"
            variant="contained"
            loading={methods.formState.isSubmitting}
          >
            <Translate>network_members.update</Translate>
          </LoadingButton>
        </DialogActions>
      </FormProvider>
    </Dialog>
  );
};

export default StatusdDialog;
